export const RoleUserRouting = [
  {
    hidden: true,
    path: "/organization/role-user/list/:id",
    name: "organization-role-user-list",
    meta: { title: "角色成员" },
    component: () =>
      import(
        /* webpackChunkName: "basic-organization-role-user" */ "@/views/organization/role-user/list/index.vue"
      ),
  },
];
